import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from '@core/services/permissions.service';

@Directive({
    selector: '[hasPermission]'
})
export class HasPermissionDirective {
    private permissionKeys: string[] = [];
    private checkMode: 'every' | 'any' = 'every';

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private permissionsService: PermissionsService
    ) { }

    @Input() set hasPermission(keys: string[] | string) {
        this.permissionKeys = Array.isArray(keys) ? keys : [keys];
        this.updateView();
    }

    @Input() set hasPermissionMode(mode: 'every' | 'any') {
        this.checkMode = mode;
        this.updateView();
    }

    private updateView(): void {
        const hasPermission =
            this.checkMode === 'every'
                ? this.permissionKeys.every(key => this.permissionsService.isPermissionEnabled(key))
                : this.permissionKeys.some(key => this.permissionsService.isPermissionEnabled(key));


        if (hasPermission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}